/**
 * Display labels for `{key:…}` tokens in NPC text (plan 13 §10), read from
 * the player's live key bindings, never hard-coded.
 */
import type { KeyBinding } from '../../../shared/CharacterTypes';
import { NPC_TEXT_KEY_RANGES } from '../../../shared/content/npcTextMarkup';
import { actionKeyLabel } from '../../systems/input/keyLabels';

export { formatKeyBinding } from '../../systems/input/keyLabels';

/** The label for one key id: an action's first binding, or a range's "first–last". */
export function npcKeyLabel(id: string, bindings: readonly KeyBinding[]): string | undefined {
  const first = (action: string) => actionKeyLabel(bindings, action);
  const range = NPC_TEXT_KEY_RANGES[id];
  if (range) {
    const [from, to] = range.map(first);
    return from && to ? `${from}–${to}` : from ?? to;
  }
  return first(id);
}
